"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocDTO = void 0;
class DocDTO {
    id;
    name;
    content;
}
exports.DocDTO = DocDTO;
